import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_financials/ap-report")({
  beforeLoad: ({ context }) => guardRoute(context.me, "ap-report"),
  component: Outlet,
});
